import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';
import Accounts from './containers/Accounts';

const CRM = {
  Helmet: lazy(() => import('./components/Helmet')),
  Accounts,
  ContactForm: lazy(() => import('./containers/Contacts/containers/ContactForm')),
  Contacts: lazy(() => import('./containers/Contacts')),
  ContactHistory: lazyNamed(() => import('./containers/Contacts/containers/History'), 'History'),
  Discounts: lazy(() => import('./containers/Discounts')),
  FeatureToggleContextProvider: lazyNamed(() => import('./context'), 'FeatureToggleContextProvider'),
  Settings: {
    Layout: lazyNamed(() => import('./containers/Settings/components/Layout'), 'Layout'),
    LockedFields: lazyNamed(() => import('./containers/Settings/containers/LockedFields'), 'LockedFields'),
  },
};

export default CRM;
export { ContactFormSearchParams } from './types';
